package com.shadowings.gero.presentation.screen.characters

import androidx.compose.ui.graphics.Color

data class ColorSectionData(
    val title: String,
    val options: List<Color>,
    val selectedIndex: Int,
    val onSelect: (Int) -> Unit
)